export class BenefitPageApiError extends Error {
  readonly type: string;
  constructor() {
    super('Benefit page api error');
    this.type = 'BenefitPageApiError';
  }
}
